export { default } from "./ContentTypeCard";
